import React from 'react';
import PropTypes from 'prop-types';
import { ExtraFooterCard } from '../cards';

/**
 * Body of the Extra Footer config modal — currently a single card that
 * already covers the whole feature (3 columns × 3 languages, with column 1
 * driven by unlayer and columns 2-3 by a simple WYSIWYG). Wrapped in a
 * modal so the contract matches the other style modals.
 *
 * value: see ExtraFooterCard for the full shape.
 * onChange(field, value) — fires per individual edit.
 */
const ExtraFooterModal = ({ value = {}, onChange, theme, t }) => (
    <ExtraFooterCard value={value} onChange={onChange} theme={theme} t={t} />
);

ExtraFooterModal.propTypes = {
    value:    PropTypes.object,
    onChange: PropTypes.func,
    theme:    PropTypes.string,
    t:        PropTypes.func,
};

export default ExtraFooterModal;
